import type { WireCard } from "@app/protocol";
import { hearts } from "@app/rules";
import { useState } from "react";
import { type AnyView, isChoosingPass, isHearts } from "../variants/types";
import { send } from "../ws/singleton";
import { cardLabel } from "./Card";
import { togglePass } from "./passToggle";

/** Your three cards for the pass, while you still choose them. */
export interface PassChoice {
  selected: ReadonlySet<string>;
  ready: boolean;
  toggle: (label: string) => void;
  submit: () => void;
}

/** The choice lives per hand: a new deal starts from nothing. Null when there is nothing to choose. */
export function usePassChoice(view: AnyView, seat: number | null): PassChoice | null {
  const [choice, setChoice] = useState<{ hand: number; labels: string[] }>({ hand: 0, labels: [] });
  if (!isHearts(view) || !isChoosingPass(view, seat)) return null;
  const held = new Set(view.yourHand.map(cardLabel));
  const labels = choice.hand === view.hand ? choice.labels.filter((label) => held.has(label)) : [];
  const cards: WireCard[] = view.yourHand.filter((card) => labels.includes(cardLabel(card)));
  return {
    selected: new Set(labels),
    ready: labels.length === hearts.PASS_COUNT,
    toggle: (label) => setChoice({ hand: view.hand, labels: togglePass(labels, label) }),
    submit: () => send({ type: "move", move: { kind: "pass", cards } }),
  };
}
